import { useEffect, useState } from "react";
import { setLoading } from "../../store/slices/auth";
import { useDispatch } from "react-redux";
import { CustomButton, showToaster, toasterTypes } from "../../widgets";
import { deleteAlertRule, getAlertRules } from "./apiController";
import ModalPopup from "../../widgets/modal";
import CreateAlertRule from "./CreateAlertRule";
import ModalComponent from "../common/Modal/modal";
import { alertRulesInfo } from "./utils";

const AddAlertRules = (props) => {
    const { projectData, onClose, forms, groupData, groups } = props;
    const [action, setaction] = useState<any>("");
    const [alertRules, setAlertRules] = useState<any>([]);
    const [selectedRule, setSelectedRule] = useState<any>();
    const dispatch = useDispatch();

    useEffect(() => {
        fetchAlertRules();
    }, []);

    async function fetchAlertRules() {
        dispatch(setLoading(true));
        try {
            const response = await getAlertRules(projectData.TopicID, groupData.id);
            setAlertRules(response.data || [])
            // showToaster(toasterTypes.SUCCESS, "Alert Rules Fetched Successfully");
        } catch (error) {
            showToaster(toasterTypes.ERROR, "Failed To Fetch Alert Rules");
        } finally {
            dispatch(setLoading(false));
        }
    }

    const handleClose = () => {
        setaction("");
        fetchAlertRules();
    };

    const handleDelete = async () => {
        setaction("")
        const rule = selectedRule;
        dispatch(setLoading(true));
        try {
            const response = await deleteAlertRule(rule?.id || "");
            if (response.success) {
                fetchAlertRules()
                showToaster(toasterTypes.SUCCESS, response.message || "Alert Rule Deleted Successfully");
            }

        } catch (error) {
            showToaster(toasterTypes.ERROR, "Failed To Delete Alert Rule");
        } finally {
            dispatch(setLoading(false));
        }
    };

    const onAction = (data, type = "") => {
        switch (type) {
            case "deleteAlertRule":
                {
                    setSelectedRule(data);
                    setaction(type);
                    break;
                }

            case "updateAlertRule":
                {
                    setSelectedRule(data);
                    setaction(type);
                    break;
                }

            default: {
                setaction(type);
                break;
            }
        }
    }

    function getFormName(formId) {
        let temp = forms.find((f) => f.id === formId)
        return temp?.form_name;
    }

    return (
        <>
            {
                (action === "add" || action === "updateAlertRule") &&
                <CreateAlertRule
                    projectData={projectData}
                    previousState={selectedRule}
                    isUpdate={action === "updateAlertRule"}
                    groupData={groupData}
                    groups={groups}
                    forms={forms}
                    onClose={handleClose}
                />
            }
            {
                action === "deleteAlertRule" &&
                <ModalPopup
                    modalType="delete"
                    modalText="Are you sure you want to delete this rule?"
                    closeModal={() => { setaction("") }}
                    onAction={() => { handleDelete() }}
                />
            }
            {
                action === "viewAlertInfo" &&
                <ModalComponent
                    width={"60%"}
                    isOpen={true}
                    onClose={() => setaction("")}
                    header={`Alert Rule Info`}
                    centered={true}
                    customClass='view-alert-rule-info-modal'
                    body={
                        <>
                            <div className="alert-info-body">
                                {alertRulesInfo?.map(rule => (
                                    <div className="alert-item" key={rule.key}>
                                        <h3 className="alert-title">{rule.title}</h3>
                                        <p className="alert-description">{rule.description}</p>
                                    </div>
                                ))}
                            </div>
                        </>
                    }
                    footer={<></>}
                />
            }

            <div className={window.innerWidth < 768 ? "add-alert-rules-container-mobile" : "add-alert-rules-container"}>
                <div className="add-alert-rules-head">
                    <div className="add-alert-rules-head-text">
                        {projectData && projectData.TopicDesc}
                    </div>
                    <div className="add-alert-rules-close-btn">
                        <i className="icon icon-close" onClick={() => onClose()}></i>
                    </div>
                </div>

                <div className="add-alert-rules-content">
                    <div className="add-alert-rules-btn-container">
                        <CustomButton type={"primary"} text={"View Alert Rules Info"} onClick={() => setaction("viewAlertInfo")} />
                        <CustomButton type={"primary"} text={"Add Alert Rule"} onClick={() => setaction("add")} />
                    </div>
                </div>

                <div className="add-alert-rules-list">
                    <h4>Alert Rules List</h4>
                    {alertRules?.length === 0 ? (
                        <p>No alert rules found.</p>
                    ) : (
                        <ul className="alert-rule-items">
                            {alertRules?.map((rule, index) => (
                                <li key={index} className="alert-rule-item">
                                    <div><strong>Alert:</strong> {rule.alert_type}</div>
                                    <div><strong>Form:</strong> {getFormName(rule.form_id)}</div>
                                    <div><strong>Field(s):</strong> {rule.field.join(", ")}</div>
                                    {rule.alert_type === "thresholdRange" ?
                                        (
                                            <>
                                                <div><strong>Min Value:</strong> {rule.min_value}</div>
                                                <div><strong>Max Value:</strong> {rule.max_value}</div>
                                            </>
                                        ) : (<div><strong>Value:</strong> {rule.min_value}</div>)
                                    }
                                    <div className="alert-rule-actions">
                                        <CustomButton type={"primary"} text={"Update"} onClick={() => onAction(rule, "updateAlertRule")} />
                                        <CustomButton type={"danger"} text={"Delete"} onClick={() => onAction(rule, "deleteAlertRule")} />
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </>
    );
};

export default AddAlertRules;
